module.exports = {
    primary: "#533EA6",
    primaryLight: "#6370EB",
    background: "#E2E4E9",
    accent: "#FFCB08",
    accentLight: "#ffd94a",
    white: "#fff"
  };